import React, { useEffect } from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { Agitation } from './components/Agitation';
import { Revelation } from './components/Revelation';
import { WhatsInside } from './components/WhatsInside';
import { WhyPrice } from './components/WhyPrice';
import { PriceCTA } from './components/PriceCTA';
import { Guarantee } from './components/Guarantee';
import { Footer } from './components/Footer';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-brand-dark pt-10 md:pt-12" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <PainPoints data-id="element-4" />
        <Agitation data-id="element-5" />
        <Revelation data-id="element-6" />
        <WhatsInside data-id="element-7" />
        <WhyPrice data-id="element-8" />
        <PriceCTA data-id="element-9" />
        <Guarantee data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}